export {
  // Native dictation configuration (v2)
  cancelNativeDictation,
  initDictationAudio,
  isDictationConfigured,
  // Event listeners
  listenDictationAnonymousLimitReached,
  listenDictationProcessing,
  listenDictationResult,
  listenDictationStart,
  // Handsfree mode listener
  listenHandsfreeStart,
  // Native sound playback
  playDictationSound,
  setDictationConfig,
  // FF sync (call when FF changes)
  setDictationEnabled,
  // Permission dialogs
  showAccessibilityRestartDialog,
  // Programmatic start (in-app dictate button on desktop)
  startProgrammaticDictation,
  stopNativeDictation,
} from './api';

// Config utilities
export {
  updateAnonymousOnboardingDictationConfig,
  updateAnonymousTrialDictationConfig,
  updateNativeDictationConfig,
} from './config';

// Permission utilities (macOS)
// Note: Input Monitoring is NOT required for Fn key detection
export { checkAccessibilityPermission, checkDictationPermissions } from './permissions';

// Types
export type {
  DictationAuthMode,
  DictationProcessingPayload,
  DictationResult,
  DictationResultPayload,
  DictationSoundType,
  DictationStartPayload,
  SetDictationConfigOptions,
} from './api';

export type { DictationPermissions, PermissionState } from './permissions';

// Provider for dictation initialization (mount in component tree)
export { shouldUseNativeAudio } from './dictation-provider.utils';
export { DictationProvider } from './DictationProvider';
